const de = {
    account: {
        addToLibraryError: 'Walk konnte nicht zur Bibliothek hinzugefügt werden.',
        cancelEditName: 'Abbrechen',
        defaultUser: 'User',
        discoverWalks: 'Walks entdecken',
        editNameButton: 'Bearbeiten',
        emptyLibrary: 'Du hast noch keine Walks in deiner Bibliothek.',
        library: 'Meine Bibliothek',
        loggingOut: 'Wird abgemeldet...',
        logout: 'Abmelden',
        namePlaceholder: 'Name',
        nameRequired: 'Name ist erforderlich.',
        nameUpdateError: 'Name konnte nicht gespeichert werden. Bitte versuche es erneut.',
        removeFromLibraryError: 'Walk konnte nicht aus der Bibliothek entfernt werden.',
        saveNameButton: 'Speichern',
        savingName: 'Wird gespeichert …',
        statusFinished: 'Abgeschlossen',
        statusInProgress: 'In Bearbeitung',
        statusNotStarted: 'Nicht begonnen',
        title: 'Mein Konto'
    },
    audioHighlightedText: {musicNoteIconLabel: 'Audio-Symbol'},
    blog: {
        metaDescription: 'Geschichten, Tipps und Neuigkeiten rund um little walks und deine Stadt.',
        title: 'Blog'
    },
    changePassword: {
        confirmPlaceholder: 'Neues Passwort wiederholen',
        currentPlaceholder: 'Aktuelles Passwort',
        error: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
        mismatch: 'Die neuen Passwörter stimmen nicht überein.',
        newPlaceholder: 'Neues Passwort',
        submit: 'Passwort ändern',
        submitting: 'Wird gespeichert …',
        success: 'Dein Passwort wurde erfolgreich geändert.',
        title: 'Passwort ändern',
        tooShort: 'Das neue Passwort muss mindestens 8 Zeichen lang sein.',
        wrongCurrent: 'Das aktuelle Passwort ist nicht korrekt.'
    },
    checkout: {
        agb: 'Ich stimme ausdrücklich zu, dass little walks vor Ablauf der Widerrufsfrist mit der '
            + 'Bereitstellung der digitalen Inhalte beginnt. Mir ist bekannt, dass mein '
            + '<0>Widerrufsrecht</0> dadurch erlischt.',
        couponError: 'Gutschein konnte nicht überprüft werden.',
        couponInvalid: 'Ungültiger Gutschein-Code.',
        error: 'Beim Checkout ist ein Fehler aufgetreten.',
        pendingMessage: 'Vielen Dank! Deine Zahlung wird noch verarbeitet. Der Walk wird freigeschaltet, '
            + 'sobald die Zahlung bestätigt ist.',
        successMessage: 'Kauf erfolgreich! Der Walk wurde deiner Bibliothek hinzugefügt.'
    },
    common: {
        back: 'Zurück',
        currentStopLink: 'Zur aktuellen Station',
        free: 'Kostenlos',
        installApp: 'Installiere little walks als App für schnelleren Zugriff',
        installNow: 'Installieren',
        km: 'km',
        loading: 'Laden...',
        logoHomeLink: 'little walks – Startseite',
        meters: 'm',
        minutes: 'Min.',
        moreOptions: 'Weitere Optionen',
        nextStop: 'Nächste Station',
        notNow: 'Nicht jetzt',
        pause: 'Pausieren',
        play: 'Abspielen',
        previousStop: 'Vorherige Station',
        starRating: '{{star}} von 5 Sternen',
        updateAvailable: 'Eine neue Version ist verfügbar',
        updateNow: 'Jetzt aktualisieren'
    },
    download: {
        downloadForOffline: 'Für Offline herunterladen',
        downloadingAudio: 'Audio wird heruntergeladen...',
        downloadingImages: 'Bilder werden heruntergeladen...',
        downloadingMap: 'Karte wird heruntergeladen...',
        error: 'Download fehlgeschlagen',
        offlineReady: 'Offline bereit',
        preparingDownload: 'Download wird vorbereitet...',
        removeDownload: 'Download entfernen',
        removing: 'Wird entfernt...',
        retry: 'Erneut versuchen',
        storedOnDevice: 'Auf Gerät gespeichert',
        updateAvailable: 'Update verfügbar',
        updateNow: 'Jetzt aktualisieren',
        updating: 'Wird aktualisiert...'
    },
    forgotPassword: {
        backToLogin: 'Zurück zur Anmeldung',
        description: 'Gib deine E-Mail-Adresse ein. Wir senden dir einen Link zum Zurücksetzen deines Passworts.',
        emailPlaceholder: 'E-Mail-Adresse',
        error: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
        sending: 'Wird gesendet …',
        submit: 'Link senden',
        success: 'Falls ein Konto mit dieser E-Mail existiert, haben wir dir einen Link zum Zurücksetzen '
            + 'geschickt. Bitte prüfe dein Postfach.',
        title: 'Passwort vergessen'
    },
    group: {
        backToHome: 'Zurück zur Startseite',
        connected: 'Verbunden',
        connectionConnected: 'Gruppe verbunden',
        connectionReconnecting: 'Verbindung wird wiederhergestellt …',
        consentLabel: 'Ich akzeptiere die Datenschutzbestimmungen und bin damit einverstanden, dass für '
            + 'diese Sitzung ein Cookie gesetzt wird.',
        consentRequired: 'Bitte akzeptiere die Datenschutzbestimmungen.',
        copiedMessage: 'Link kopiert!',
        copyLinkButton: 'Link kopieren',
        createButton: 'Hörgruppe erstellen',
        creating: 'Wird erstellt …',
        disconnected: 'Getrennt',
        endButton: 'Gruppe beenden',
        endedMessage: 'Diese Gruppe wurde beendet.',
        enterCodePlaceholder: 'Gruppen-Code',
        enterCodeRequired: 'Bitte gib einen Code ein.',
        enterCodeSubmit: 'Weiter',
        joinCodeExpired: 'Dieser Code ist nicht mehr gültig. Bitte neu scannen.',
        joinCodeLabel: 'Oder gib diesen Code ein:',
        joinGenericError: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
        joinLinkLabel: 'Oder teile diesen Link:',
        joinNamePlaceholder: 'Dein Name',
        joinNameRequired: 'Name ist erforderlich.',
        joinSubmit: 'Beitreten',
        joinTitle: 'Hörgruppe beitreten',
        kickedMessage: 'Du wurdest von der Gruppe entfernt.',
        leaderDisconnected: 'Verbindung zum Guide unterbrochen. Warte auf Rückkehr …',
        membersConnected: '{{count}} Personen verbunden',
        membersTitle: 'Verbundene Mitglieder',
        noMembers: 'Noch keine Mitglieder verbunden.',
        removeMember: 'Entfernen',
        resumePlaybackButton: 'Wiedergabe fortsetzen',
        rotateCodeButton: 'Neuen Code generieren',
        shareButton: 'Teilen',
        title: 'Gruppen-Hören',
        waitingForLeader: 'Warte auf den Guide …'
    },
    guide: {
        bio: 'Biografie',
        email: 'E-Mail',
        personalTour: 'Persönliche Führung',
        personalTourAvailable: 'Persönliche Führungen buchbar',
        phone: 'Telefon',
        price: 'Preis',
        website: 'Website'
    },
    home: {
        allCities: 'Alle Städte',
        allTours: 'Alle Touren',
        categoryDiscovery: 'Entdeckung',
        categoryHistorical: 'Historisch',
        categoryNature: 'Natur',
        categoryScenic: 'Panorama',
        featuredTitle: 'Empfohlen',
        filterFree: 'Kostenlos',
        filterPaid: 'Kostenpflichtig',
        filterShort: 'Kurz (unter 1h)',
        noResults: 'Keine Walks gefunden.',
        noResultsHint: 'Versuche deine Suche oder Filter anzupassen.',
        searchPlaceholder: 'Walks durchsuchen...',
        title: 'little walks',
        viewAll: 'Alle anzeigen'
    },
    karte: {
        allCategories: 'Alle',
        metaDescription: 'Entdecke alle little walks auf der Karte und finde Spaziergänge in deiner Nähe.',
        title: 'Karte'
    },
    languagePopup: {
        confirm: 'Weiter',
        subtitle: 'Wähle deine bevorzugte Sprache.',
        title: 'Willkommen bei little walks'
    },
    login: {
        email: 'E-Mail',
        error: 'Login fehlgeschlagen.',
        forgotPassword: 'Passwort zurücksetzen',
        noAccount: 'Noch kein Konto?',
        noPassword: 'Passwort vergessen?',
        password: 'Passwort',
        register: 'Registrieren',
        submit: 'Anmelden',
        submitting: 'Wird angemeldet...',
        title: 'Anmelden'
    },
    nav: {
        account: 'Konto',
        faq: 'FAQ',
        home: 'Start',
        library: 'Bibliothek',
        login: 'Anmelden',
        map: 'Karte',
        settings: 'Einstellungen'
    },
    nearbyWaypoints: {
        distanceLabel: '{{distance}} entfernt',
        heading: 'Startpunkte in deiner Nähe',
        loadMore: 'Mehr laden',
        modeAll: 'Alle Stationen'
    },
    notFound: {
        backToHome: 'Zur Startseite',
        subtitle: 'Diesen Weg gibt es leider nicht. Starte einfach neu von der Startseite.',
        title: 'Seite nicht gefunden'
    },
    offline: {
        cachedWalks: 'Heruntergeladene Walks',
        empty: 'Du hast noch keine Walks heruntergeladen. Lade Walks herunter, um sie offline zu nutzen.',
        openWalk: 'Walk öffnen',
        subtitle: 'Du kannst weiterhin deine heruntergeladenen Walks anhören.',
        title: 'Du bist offline'
    },
    promo: {priceInstead: '{{price}} statt {{original}}'},
    protectedWalk: {
        backToLibrary: 'Zurück zur Bibliothek',
        guide: 'Guide:',
        map: 'Karte',
        mapPlaceholder: 'Karten-Ansicht (wird implementiert)',
        openWaypoint: 'Station öffnen',
        waypoints: 'Stationen'
    },
    purchases: {
        couponIconLabel: 'Gutschein',
        empty: 'Du hast noch keine Käufe getätigt.',
        status: {
            completed: 'Abgeschlossen',
            pending: 'Ausstehend',
            refunded: 'Erstattet'
        },
        title: 'Meine Käufe',
        unknownWalk: 'Unbekannter Walk'
    },
    register: {
        email: 'E-Mail',
        error: 'Registrierung fehlgeschlagen.',
        hasAccount: 'Bereits ein Konto?',
        login: 'Anmelden',
        name: 'Name',
        newsletter: 'Ich möchte den Newsletter erhalten (optional).',
        password: 'Passwort',
        privacy: 'Ich habe die <0>Datenschutzerklärung</0> gelesen und akzeptiere sie.',
        submit: 'Konto erstellen',
        submitting: 'Wird erstellt...',
        title: 'Registrieren'
    },
    resetPassword: {
        confirmPlaceholder: 'Passwort wiederholen',
        description: 'Wähle ein neues Passwort für dein Konto.',
        error: 'Der Link ist ungültig oder abgelaufen. Bitte fordere einen neuen an.',
        invalidToken: 'Dieser Link ist ungültig oder unvollständig. Bitte fordere einen neuen an.',
        mismatch: 'Die Passwörter stimmen nicht überein.',
        passwordPlaceholder: 'Neues Passwort',
        submit: 'Passwort speichern',
        submitting: 'Wird gespeichert …',
        success: 'Dein Passwort wurde erfolgreich geändert. Du kannst dich jetzt anmelden.',
        title: 'Passwort zurücksetzen',
        tooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein.'
    },
    settings: {
        account: 'Konto',
        analyticsLinkingDescription: 'Verknüpft deine Nutzung der Website mit deinem Konto, damit wir '
            + 'wiederkehrendes Nutzungsverhalten in unserer Analyse-Software auswerten können.',
        analyticsLinkingDisabled: 'Aus',
        analyticsLinkingEnabled: 'An',
        analyticsLinkingError: 'Einstellung konnte nicht gespeichert werden. Bitte versuche es erneut.',
        analyticsLinkingLogoutHint: 'Beim Deaktivieren wirst du automatisch ausgeloggt, damit die aktuelle '
            + 'Sitzung nicht weiter mit deinem Konto verknüpft bleibt.',
        imprint: 'Impressum',
        language: 'Sprache',
        languageDe: 'Deutsch',
        languageEn: 'English',
        legal: 'Rechtliches',
        location: 'Standort',
        locationDenied: 'Standortzugriff im Browser blockiert. Bitte erlaube ihn in den Browser-Einstellungen.',
        locationDescription: 'Zeigt deinen Standort auf der Karte an, damit du die Stationen leichter finden kannst.',
        locationDisabled: 'Aus',
        locationEnabled: 'An',
        privacy: 'Datenschutz',
        title: 'Einstellungen'
    },
    tourComplete: {
        ctaLabel: 'Tour abschließen & ins Journal speichern',
        feedbackLabel: 'Teile deine Eindrücke',
        feedbackPlaceholder: 'Was hast du heute entdeckt?',
        finalStopReached: 'Letzter Halt erreicht',
        rateJourney: 'Bewerte diese Reise',
        shareJourney: 'Reise mit Freunden teilen',
        subtitle: 'Du hast alle {{count}} Stationen abgeschlossen.',
        title: 'Eine wunderschöne Reise'
    },
    tourOverview: {
        active: 'AKTUELL',
        completed: 'ABGESCHLOSSEN',
        currentJourney: 'AKTUELLE REISE',
        currentStop: 'Aktuelle Station',
        expandMap: 'Karte erweitern',
        expeditionPath: 'Der little walk',
        itinerary: 'Tour-Streckenplan',
        nowPlaying: 'Wird abgespielt',
        pending: 'OFFEN',
        showMore: '{{count}} weitere Stationen anzeigen'
    },
    verify: {
        checkEmail: 'Bitte prüfe dein Postfach und klicke auf den Bestätigungslink.',
        checkEmailTitle: 'E-Mail bestätigen',
        error: 'Die Verifizierung ist fehlgeschlagen. Der Link ist möglicherweise abgelaufen.',
        login: 'Zur Anmeldung',
        success: 'Deine E-Mail wurde erfolgreich bestätigt. Du kannst dich jetzt anmelden.',
        title: 'E-Mail bestätigen',
        verifying: 'Wird verifiziert...'
    },
    walkDetail: {
        adding: 'Wird hinzugefügt...',
        addToLibrary: 'Zur Bibliothek hinzufügen',
        buy: 'Kaufen',
        buyComingSoon: 'Kaufen (bald verfügbar)',
        categories: 'Kategorien',
        details: 'Details',
        distance: 'Distanz',
        duration: 'Dauer',
        guide: 'Guide',
        inLibrary: 'In deiner Bibliothek —',
        map: 'Karte',
        mapPlaceholder: 'Karten-Ansicht (wird implementiert)',
        moreLockedLocations: 'weitere Stationen',
        open: 'Öffnen',
        reviews: 'Bewertungen',
        season: 'Saison',
        suitableFor: 'Geeignet für',
        suitableForChildren: 'Kinder',
        suitableForDogs: 'Hunde',
        suitableForFamilies: 'Familien',
        suitableForSeniors: 'Senioren',
        suitableForStroller: 'Kinderwagen',
        suitableForWheelchair: 'Rollstuhl',
        terrain: 'Untergrund',
        terrainAsphalt: 'Asphalt',
        terrainCobblestone: 'Kopfsteinpflaster',
        terrainForestPath: 'Waldweg',
        terrainGravel: 'Kies',
        terrainMixed: 'Gemischt',
        waypoints: 'Stationen',
        website: 'Website'
    },
    walkMap: {
        close: 'Schließen',
        detailsLink: 'Details ansehen',
        fountainLabel: 'Trinkbrunnen: {{name}}',
        fountainsHide: 'Trinkbrunnen ausblenden',
        fountainsShow: 'Trinkbrunnen anzeigen',
        fullscreenEnter: 'Vollbild anzeigen',
        fullscreenExit: 'Vollbild verlassen',
        fullscreenHintButton: 'Vollbild öffnen',
        loading: 'Karte wird geladen…',
        locateMe: 'Meinen Standort anzeigen',
        twoFingerHint: 'Zwei Finger zum Bewegen der Karte verwenden. Im Vollbildmodus reicht ein Finger.'
    },
    walks: {
        allCities: 'Alle Städte',
        metaDescription: 'Entdecke alle little walks – geführte Spaziergänge mit Audioguide in deiner Stadt.',
        noResults: 'Keine Walks gefunden.',
        searchPlaceholder: 'Walks durchsuchen...',
        title: 'Alle Walks'
    },
    waypoint: {
        categoryLabel: 'Station {{number}}',
        chapter: 'Kapitel',
        explored: 'erkundet',
        nextWaypoint: 'Nächste Station',
        storyTranscript: 'Geschichts-Transkript',
        upNext: 'Als Nächstes',
        upNextComplete: 'Tour abschließen',
        walkTime: '{{min}} Min. Fußweg'
    }
};

export default de;